/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Reducer for login user
 */

import {
  RESET_USER_PASSWORD,
  RESET_PASS_TOKEN_DETAILS,
  RESET_PASSWORD_FINAL,
  GET_ISSUE_TYPE,
  REQUEST_CONTACT_ADMIN,
  SESSION_TIMEOUT,
  SESSION_TIMEOUT_SETTINGS,
  USER_LOGOUT,
  USER_PROFILE,
  ORG_PROFILE,
  UPDATE_ORG_PROFILE,
  FETCH_DEPARTMENT_DETAILS,
  UPDATE_DEPARTMENT_DETAILS,
  FETCH_DEPARTMENT_DETAILS_LOADING,
  FETCH_USERFROM_DEPT_LOADING,
  FETCH_USERFROM_DEPT,
} from '../actions/types';

const initialState = {
  userDetails: {},
  orgDetails: {},
  session: {},
  updateDepartments: {}, 
  fetchDepartments: {},
  fetchDepartmentsLoading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_PASSWORD_FINAL:
      return {
        ...state,
        resetPassword: action.payload,
      };
    case RESET_PASS_TOKEN_DETAILS:
      return {
        ...state,
        resetPasswordTokenDetails: action.payload,
      };
    case GET_ISSUE_TYPE:
      return {
        ...state,
        issueType: action.payload,
      };
    case SESSION_TIMEOUT:
      return {
        ...state,
        userSessionData: action.payload,
      };
    case REQUEST_CONTACT_ADMIN:
      return {
        ...state,
        contactAdmin: action.payload,
      };
    case RESET_USER_PASSWORD:
      return {
        ...state,
        resetUserPassword: action.payload,
      };
    case USER_LOGOUT:
      return {
        ...state,
        logout: action.payload,
      };

    case SESSION_TIMEOUT_SETTINGS:
      return {
        ...state,
        session: action.payload,
      };
    //-------**--V2.0 User and Org Profile--**--------------
    case USER_PROFILE:
      return {
        ...state,
        userDetails: action.payload,
      };
    case ORG_PROFILE:
      return {
        ...state,
        orgDetails: action.payload,
      };
      case UPDATE_ORG_PROFILE:
        return {
          ...state,
          updateOrgDetails: action.payload,
        };
      case UPDATE_DEPARTMENT_DETAILS:
        return {
          ...state,
          updateDepartments: action.payload,
        };
        case FETCH_DEPARTMENT_DETAILS_LOADING:
          return {
            ...state,
            fetchDepartmentsLoading: action.payload,
          }; 
        case FETCH_DEPARTMENT_DETAILS:
          return {
            ...state,
            fetchDepartments: action.payload,
          };  
          case FETCH_USERFROM_DEPT_LOADING:
            return {
              ...state,
              fetchUserfromDeptLoading: action.payload,
            }; 
          case FETCH_USERFROM_DEPT:
            return {
              ...state,
              fetchUserfromDeptDetails: action.payload,
            }; 
    default:
      return state;
  }
}
